/* Cliente del companion para la carpeta de proyecto (Fase 1). */

import { companionError } from "./companion";
export interface ProjFile {
  path: string;
  rel: string;
  name: string;
  ext: string;
  size: number;
}

const COMPANION = "https://localhost:3001";

export async function listProject(dir: string): Promise<{ root: string; files: ProjFile[] }> {
  let res: Response;
  try {
    res = await fetch(`${COMPANION}/project?dir=${encodeURIComponent(dir)}`);
  } catch (e: any) {
    throw new Error(
      companionError(e),
    );
  }
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(`No se pudo leer la carpeta: ${t.slice(0, 200)}`);
  }
  return res.json();
}
